export const getPrincipalesForm = () => ({
    txtRazonSocialEmpresa: {
        name: "txtRazonSocialEmpresa",
        label: "Razón social:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha ingresado la razón social",
    },
    txtTipoServicioSuministra: {
        name: "txtTipoServicioSuministra",
        label: "Tipo de servicio:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha ingresado el tipo de servicio",
    },
});

export const getInformacionComplementariaForm = () => ({
    txtMonedaFacturacion: {
        name: "txtMonedaFacturacion",
        label: "Monedas de facturación:",
        value: [],
        required: true,
        error: false,
        helper: "No se han seleccionado las monedas de facturación",
    },
    txtCertificados: {
        name: "txtCertificados",
        label: "Certificados:",
        value: "",
        required: true,
        error: false,
        helper: "No se han seleccionado los certificados",
    },
    txtOtrosCertificados: {
        name: "txtOtrosCertificados",
        label: "Otros certificados:",
        value: "",
        required: false,
        error: false,
        helper: "No se han ingresado otros certificados",
        placeholder: "Ingrese el nombre de los certificados separados por coma",
    },
    txtCondicionPago: {
        name: "txtCondicionPago",
        label: "Condición de pago que otorgaría:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha seleccionado la condición de pago",
    },
    txtNumeroTotalClientes: {
        name: "txtNumeroTotalClientes",
        label: "Número total de clientes:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha ingresado el número total de clientes",
    },
    txtPorcentajeParticipacionSectorPrivado: {
        name: "txtPorcentajeParticipacionSectorPrivado",
        label: "Porcentaje de participación del sector privado:",
        value: 50,
        required: true,
        error: false,
        helper: "Del total del cliente, cual es el % que pertenece al sector privado",
    },
    txtPorcentajeParticipacionSectorGobierno: {
        name: "txtPorcentajeParticipacionSectorGobierno",
        label: "Porcentaje de participación del sector gobierno:",
        value: 50,
        required: true,
        error: false,
        helper: "Del total del cliente, cual es el % que pertenece al sector gobierno",
    },
    txtRangoIngresosAnuales: {
        name: "txtRangoIngresosAnuales",
        label: "Rango de ingresos anuales:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha seleccionado el rango de ingresos anuales",
    },
    txtSectorProveedor: {
        name: "txtSectorProveedor",
        label: "Sector al que pertenece:",
        value: "",
        required: true,
        error: false,
        helper: "No se ha seleccionado el sector",
    },
    txtOtrosSectoresProveedor: {
        name: "txtOtrosSectoresProveedor",
        label: "Otros sectores:",
        value: "",
        required: false,
        error: false,
        helper: "No se han ingresado otros sectores",
        placeholder: "Ingrese el nombre de los sectores separados por coma",
    },
    txtAvisoPrivacidadd: {
        name: "txtAvisoPrivacidadd",
        label: "Aviso de privacidad:",
        value: false,
        required: true,
        error: false,
        helper: "Para continuar, acepte el aviso de privacidad",
    },
});
